import { render, staticRenderFns } from "../templates/normal_fcont_152.html?vue&type=template&id=3c1db522&scoped=true&"
import script from "./normal_fcont_152.vue?vue&type=script&lang=js&"
export * from "./normal_fcont_152.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1db522",
  null
  
)

export default component.exports